module.exports = __webpack_public_path__ + "static/3-ce4ad79f192a09b430a31dab181ab146.jpg";